import React from "react";

type Props = {
  node?: any;
};

function ContributorCard({ node }: Props) {
  const { title, contributors } = node;

  // 後方互換性のため、contributorプロパティもサポート
  const contributorList =
    contributors || (node.contributor ? [node.contributor] : []);

  return (
    <div className="my-10 bg-neutral-99 py-4 px-6 rounded">
      <div className="mb-3 text-xs font-semibold text-neutral-60 leading-[22px]">
        {title}
      </div>
      <div className="space-y-4">
        {contributorList.map((contributor: any, index: number) => (
          <>
            <div
              key={contributor.yamlId || index}
              className="flex gap-4 items-start"
            >
              {contributor.image && (
                <img
                  src={contributor.image.imgix?.url}
                  alt={contributor.name}
                  loading="eager"
                  className="rounded-full w-[74px] h-[74px] shrink-0"
                />
              )}
              <div>
                <div className="mb-2 text-neutral-30 font-semibold leading-[22px]">
                  {contributor.name}
                </div>
                <p className="text-2xs leading-[22px]">
                  {contributor.biography}
                </p>
              </div>
            </div>

            {index !== contributors.length - 1 && (
              <div className="h-[1px] bg-neutral-90"></div>
            )}
          </>
        ))}
      </div>
    </div>
  );
}

export default ContributorCard;
